import { Component, Injectable, OnInit } from '@angular/core';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { ShipReportService } from '../../services/ship-report.service';
import { ToastrService } from 'ngx-toastr';
import { batch } from './batch.interface';
import { EntitlementService } from 'src/app/services/entitlement.service';
import { MessageService } from '../../services/message.service';

export interface dropDownObject {
  name: string;
  value: string;
}
@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-ship-reports',
  templateUrl: './ship-reports.component.html',
  styleUrls: ['./ship-reports.component.css']
})
export class ShipReportsComponent implements OnInit {
  locations = [];
  reportNames = [];
  location: any;
  report: any;
  startDate: NgbDate;
  endDate: NgbDate;
  batch: batch;
  transactions = [];
  text: string;
  spinner = false;
  batches: batch[] = [];
  passedBatch: string;
  loading = false;
  shipReports = [];
  shoreReports = [];
  dateChanged = false;

  constructor(
    private calendar: NgbCalendar,
    private shipReportService: ShipReportService,
    private messageService: MessageService,
    private toastrService: ToastrService,
    private entitlementService: EntitlementService
  ) {}

  ngOnInit() {
    this.loading = true;
    const passsedReport = this.shipReportService.getReport();
    if (passsedReport) {
      this.shipReportService.clearReport();
    }
    this.endDate = this.calendar.getToday();
    this.startDate = this.calendar.getPrev(this.endDate, 'd', 30);
    this.shipReportService.getSearchPage().subscribe(
      (data: object) => {
        this.locations = data['ships'];
        this.shoreReports = data['shoreReportNames'];
        this.shipReports = data['shipReportNames'];

        if (this.hasEntitlements('REPORTS_SHORE')) {
          this.locations.unshift({ shipLocation: 'Shore', shipName: 'Shore' });
          this.reportNames = this.shoreReports;
        } else {
          this.reportNames = this.shipReports;
        }

        if (passsedReport !== null) {
          const location = passsedReport['location'];
          this.locations.forEach((loc) => {
            if (loc.shipLocation === location) {
              this.location = loc;
            }
          });
          this.passedBatch = passsedReport['batch'];
          const newBatch: batch = { batchId: this.passedBatch };
          this.batch = newBatch;
        } else {
          this.location = this.locations[0];
        }
        this.report = this.reportNames[0];
        this.changeView();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  searchTransactions() {
    this.spinner = true;
    let batchId: string;
    if (this.batch === undefined) {
      if (this.passedBatch !== null || this.passedBatch !== undefined) {
        batchId = 'None';
      } else {
        batchId = this.passedBatch;
      }
    } else {
      if (this.batch.batchId !== '') {
        batchId = this.batch.batchId;
      } else {
        batchId = 'None';
      }
    }
    let name: string;
    if (this.report.name.includes('(')) {
      name = this.report.name.split('(')[0];
    } else {
      name = this.report.name;
    }
    const trans = {
      reportName: name,
      location: this.location['shipLocation'],
      batchId: batchId,
      startDate:
        this.startDate.month +
        '/' +
        this.startDate.day +
        '/' +
        this.startDate.year,
      endDate:
        this.endDate.month + '/' + this.endDate.day + '/' + this.endDate.year
    };
    this.shipReportService.searchTransactions(trans).subscribe(
      (data: object[]) => {
        this.transactions = data;
        if (this.transactions.length === 0) {
          this.text = '';
        } else {
          this.text = this.transactions.length + ' report(s) found';
        }
        this.spinner = false;
      },
      (err) => {
        this.spinner = false;
        this.toastrService.error('Had an issue finding reports.');
      }
    );
  }

  changeDate() {
    this.dateChanged = true;
    this.searchTransactions();
  }

  changeView() {
    this.spinner = true;
    if (this.location['shipName'] === 'Shore') {
      if (!this.dateChanged) {
        this.startDate = this.calendar.getPrev(this.endDate, 'd', 30);
      }
      this.reportNames = this.shoreReports;
      this.report = this.reportNames[0];
      this.loading = false;
      this.searchTransactions();
    } else {
      if (!this.dateChanged) {
        this.startDate = this.calendar.getPrev(this.endDate, 'd', 7);
      }
      this.reportNames = this.shipReports;
      this.report = this.reportNames[0];
      this.shipReportService
        .getBatchId(this.location['shipLocation'].toString())
        .subscribe(
          (data: batch[]) => {
            this.spinner = false;
            this.batches = data;
            if (!this.passedBatch) {
              this.batch = this.batches[0];
            } else {
              this.batches.forEach((bat) => {
                if (bat.batchId === this.passedBatch) {
                  this.batch = bat;
                  this.passedBatch = null;
                }
              });
            }
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            this.spinner = false;
            this.toastrService.error('Had an issue finding reports.');
          },
          () => {
            this.searchTransactions();
          }
        );
    }
  }

  showShipReportDetails(data: string, fileName: string) {
    this.shipReportService.downloadReport(data).subscribe(
      (response) => {
        const reportFile = new Blob([response]);
        var downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.style.display = 'none';
        downloadLink.href = URL.createObjectURL(reportFile);
        downloadLink.download = fileName;
        downloadLink.click();

        URL.revokeObjectURL(downloadLink.href);
        downloadLink.remove();
      },
      (error) => this.messageService.error(error.message)
    );
  }

  removeFileExtension(fileName: string): string {
    return fileName.substr(0, fileName.lastIndexOf('.'));
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }
}
